import React from "react";
import clsx from "clsx";

import CheckIcon from "@material-ui/icons/Check";
import TrainerIcon from "@material-ui/icons/Person";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { getRequiredValue } from "utils/required-values-utils";
import { getHorseAge } from "utils/horse";
import { parseHorseGenderFull } from "utils/enum-parser";
import { EMPTY_STRING, UNKNOWN } from "common/constants";
import HorseIcon from "components/Icons/Horse";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import HighLightedItem from "../HighLightedItem";

import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
  searchValue: string;
  isActive: boolean;
}

const HorseItem = (props: IProps) => {
  const { horse, isActive, searchValue } = props;

  const classes = useStyles();

  const { currentUser } = useLoggedInUser();
  const isCurrentUserTrainer = Boolean(currentUser?.isTrainer);

  const trainerName = `${getRequiredValue(
    horse.trainer?.firstName,
    EMPTY_STRING
  )} ${getRequiredValue(horse.trainer?.lastName, EMPTY_STRING)}`;

  const itemIcon = isActive ? (
    <CheckIcon className={classes.checkIcon} />
  ) : (
    <HorseIcon className={clsx(classes.itemIcon, classes.itemNotActive)} />
  );

  const itemContent = isCurrentUserTrainer ? (
    <>
      <div>{`${getHorseAge(horse)} years old`}</div>
      <div className={classes.itemHorseDetailsGender}>
        {parseHorseGenderFull(horse.gender, UNKNOWN)}
      </div>
    </>
  ) : (
    <>
      <div>{trainerName}</div>
      <TrainerIcon
        className={clsx(classes.itemIcon, classes.itemHorseTrainerIcon, {
          [classes.itemActive]: isActive,
          [classes.itemNotActive]: !isActive
        })}
      />
    </>
  );

  return (
    <div className={clsx(classes.item, { [classes.itemActive]: isActive })}>
      <div className={classes.itemHorseName}>
        {itemIcon}
        <div className={classes.itemHorseNameTitle}>
          <HighLightedItem value={horse.name} searchValue={searchValue} />
        </div>
      </div>

      <div
        className={clsx(classes.itemHorseDetails, {
          [classes.itemHorseDetailsTrainer]: !isCurrentUserTrainer
        })}
      >
        {itemContent}
      </div>
    </div>
  );
};

export default React.memo(HorseItem);
